"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuperBonusService = void 0;
const api_1 = require("./api");
const PATH = 'superbonus/api/v2';
class SuperBonusService {
    static async fetchPromotionData(drawIds) {
        try {
            if (drawIds.length === 0) {
                return {};
            }
            const ids = drawIds.join(',');
            return await api_1.API.get({ url: `${PATH}/super-bonus/draws?ids=${ids}` });
        }
        catch (error) {
            throw error;
        }
    }
    static async fetchSuperBonus(superBonusKey) {
        return api_1.API.get({
            url: `${PATH}/super-bonus/eligibleGames?superBonusKey=${superBonusKey}`
        });
    }
}
exports.SuperBonusService = SuperBonusService;
//# sourceMappingURL=super-bonus-service.js.map